
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

interface ShareFormSectionProps {
  onShareEntry: (email: string) => Promise<void>;
  isSharing: boolean;
}

const ShareFormSection = ({ onShareEntry, isSharing }: ShareFormSectionProps) => {
  const [email, setEmail] = useState("");
  
  const handleShare = async () => {
    await onShareEntry(email);
    setEmail("");
  };
  
  return (
    <div className="flex items-end gap-2">
      <div className="grid flex-1 gap-2">
        <Label htmlFor="email">Email address</Label>
        <Input
          id="email"
          type="email"
          placeholder="family@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isSharing}
        />
      </div>
      <Button 
        onClick={handleShare} 
        disabled={isSharing || !email}
        className="mb-px"
      >
        {isSharing ? "Sharing..." : "Share"}
      </Button>
    </div>
  );
};

export default ShareFormSection;
